<template>
  <div class="container">
    <div class="uni-padding-wrap uni-common-mt">
      <div class="uni-common-frency" v-if='frequencyDefualtType==1|frequencyDefualtType==2'>
        <div
          v-for="(item, index) in items"
          :class="{ active: currentIndex == index }"
          class="segmented-control-item"
          :key="index"
          @click="onClickItem(index)"
        >
          {{ item }}
        </div>
      </div>
        <div :style="{'width':frequencyDefualtType==3|frequencyDefualtType==4?'100%':''}" class="search-item" @click="routeSearch">
          <img
            class="search-image"
            src="../../static/bookCity_search.png"
            mode=""
            alt=""
          />
          <span class="search-text">搜索书名和作者名</span>
        </div>
    </div>
    <div class="contaner-banner">
      <!-- banner -->
      <div class="page-section-spacing" v-if="BannerList.length > 0">
        <mt-swipe
          ref="swipe"
          :auto="4000"
          :defaultIndex="swiperIndex"
          class="swiper"
        >
          <mt-swipe-item
            v-for="(item, index) in BannerList"
            :key="index"
            @click.native="goDetail(item)"
          >
            <div class="swiper-item uni-bg-red">
              <img
                :src="item.bannerLogoUrl"
                class="swiper-image"
                mode="widthFix"
              /></div
          ></mt-swipe-item>
        </mt-swipe>
        <!-- <swiper :current="swiperIndex" :circular="true" class="swiper" indicator-color="rgba(0,0,0,.5)"
					indicator-active-color="#ffffff" :indicator-dots="BannerList.length==1?false:true" :autoplay="true">
					<swiper-item v-for="(item,index) in BannerList" :key="index" @click="goDetail(item)">
						<div class="swiper-item uni-bg-red">
							<img :src="item.bannerLogoUrl" class="swiper-image" mode="widthFix" />
						</div>
					</swiper-item>
				</swiper> -->
      </div>
      <!-- 限时免费入口 -->
      <div class="uni-page-sort" v-if="diamondareaShowType">
        <div class="uni-page-sort-item" @click="routerSort">
          <img
            class="uni-page-sort-image"
            src="../../static/bookcity_sort.png"
            mode=""
          />
          <span class="uni-page-sort-text">排行榜</span>
        </div>
        <div class="uni-page-sort-item" @click="routerClass">
          <img
            class="uni-page-sort-image"
            src="../../static/bookcity_fen.png"
            mode=""
          />
          <span class="uni-page-sort-text">分类</span>
        </div>
        <div class="uni-page-sort-item" @click="routerFree">
          <img
            class="uni-page-sort-image"
            src="../../static/bookcity_mian.png"
            mode=""
          />
          <span class="uni-page-sort-text">限时免费</span>
        </div>
      </div>
    </div>
    <!-- 书城组件 -->
    <div class="uni-components">
      <div v-for="(item, index) in muchCompontent" :key="index">
        <div class="uni-components-title" v-if="item.titleShow==0">
          <span>{{ item.assemblyTitle }}</span>
        </div>
        <!-- 三本平铺 -->
        <div v-if="item.componentStyle == 0" class="uni-components-item-hot">
          <div class="list-content">
            <div
              v-for="(itemChild, idx) in item.bookList"
              :key="idx"
              @click="pageRead(itemChild, item)"
            >
            <threeCompontent :itemChild="itemChild" ></threeCompontent>
            </div>
          </div>
        </div>
           <!-- 4本1带3 -->
           <div v-if="item.componentStyle == 3" class="uni-components-item-list">
            <div class='list_top'  @click="pageRead(item.bookList[0], item)">
              <ListitemFour :itemChild="item.bookList[0]"></ListitemFour>
            </div>
            <div class="list-content">
            <div
            v-if="idx!=0"
              v-for="(itemChild, idx) in item.bookList"
              :key="idx"
              @click="pageRead(itemChild, item)"
            >
            <threeCompontent :itemChild="itemChild" ></threeCompontent>
            </div>
          </div>
        </div>
         <!-- 5本1带4 -->
         <div v-if="item.componentStyle == 4" class="uni-components-item-list">
            <div class='list_top' @click="pageRead(item.bookList[0], item)">
              <fiveCompontent :itemChild="item.bookList[0]"></fiveCompontent>
            </div>
            <div class="list-content-four">
            <div
            v-if="idx!=0"
              class="bookFourItem"
              v-for="(itemChild, idx) in item.bookList"
              :key="idx"
              @click="pageRead(itemChild, item)"
            >
            <fourCompontent :itemChild="itemChild" ></fourCompontent>
            </div>
          </div>
        </div>
         <!-- 6本两横排 -->
         <div v-if="item.componentStyle == 5" class="uni-components-item-list">
            <div class="list-content" style="margin-bottom:1rem">
            <div
              v-for="(itemChild, idx) in item.bookList"
              :key="idx"
              @click="pageRead(itemChild, item)"
              :style="{'margin-bottom':idx<=2&&item.bookList.length>3?'1rem':''}"
            >
            <sixCompontent :itemChild="itemChild" ></sixCompontent>
            </div>
          </div>
        </div>
         <!-- 8本两横排 -->
         <div v-if="item.componentStyle == 6" class="uni-components-item-list">
            <div class="list-content-four" >
            <div
              v-for="(itemChild, idx) in item.bookList"
              :key="idx"
              @click="pageRead(itemChild, item)"
              :style="{'margin-bottom':idx<=3&&item.bookList.length>4?'1rem':''}"
            >
            <eightCompontent :itemChild="itemChild" ></eightCompontent>
            </div>
          </div>
        </div>
           <!-- 9本1带8 -->
           <div v-if="item.componentStyle == 7" class="uni-components-item-list">
            <div class='list_top' @click="pageRead(item.bookList[0], item)">
              <fiveCompontent :itemChild="item.bookList[0]"></fiveCompontent>
            </div>
            <div class="list-content-four">
            <div
            v-if="idx!=0"
              v-for="(itemChild, idx) in item.bookList"
              :key="idx"
              @click="pageRead(itemChild, item)"
              :style="{'margin-bottom':idx<=4?'1rem':''}"
            >
            <eightCompontent :itemChild="itemChild" :isNine="true" ></eightCompontent>
            </div>
          </div>
        </div>
        <!-- 单本列表式 -->
        <div v-if="item.componentStyle == 1" class="uni-components-item-list">
          <div
            v-for="(itemChild, idx) in item.bookList"
            :key="idx"
            @click="pageRead(itemChild, item)"
          >
            <uniListitem :itemChild="itemChild"></uniListitem>
          </div>
        </div>
         <!-- 2列本列表式 -->
         <!--  -->
         <div v-if="item.componentStyle == 8" class="uni-components-item-list">
          <div class="list-content">
            <nineCompontent  v-for="(itemChild, idx) in item.bookList"
            :key="idx"
            @click.native="pageRead(itemChild, item)" :itemChild="itemChild" :style="{'margin-bottom':(idx==item.bookList.length-1||idx==item.bookList.length-2)?'0':'1.25rem'}"></nineCompontent>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部信息流 -->
    <div class="uni-components">
      <div>
        <div class="uni-components-title" v-if="multibook.titleShow==0">
          <span>{{ multibook.showTitle }}</span>
        </div>
        <!-- 单本底部信息流 -->
        <div v-if="multibook.componentStyle==2" class="uni-components-item-list">
          <ul
            v-infinite-scroll="loadMore"
            :infinite-scroll-disabled="loading"
            infinite-scroll-distance="10"
          >
            <li
              v-for="(itemChild, idx) in multibook.list"
              :key="idx"
              @click="pageRead(itemChild, multibook)"
            >
              <uniListitem :itemChild="itemChild"></uniListitem>
            </li>
          </ul>
        </div>
        <!-- 2列底部信息流 -->
        <div v-if="multibook.componentStyle==9" class="uni-components-item-list">
          <ul
            v-infinite-scroll="loadMore"
            :infinite-scroll-disabled="loading"
            infinite-scroll-distance="10"
            class="list-content"
          >
            <nineCompontent  class='book_bg'
              v-for="(itemChild, idx) in multibook.list"
              :key="idx"
              @click.native="pageRead(itemChild, multibook)" :itemChild="itemChild"  :style="{'margin-bottom':idx==multibook.list.length-1||idx==multibook.list.length-2?'0':'1.25rem'}"></nineCompontent>
          </ul>
        </div>
    <!-- 无封面底部信息流 -->
    <div v-if="multibook.componentStyle==10" class="uni-components-item-list">
          <ul
            v-infinite-scroll="loadMore"
            :infinite-scroll-disabled="loading"
            infinite-scroll-distance="10"
            class="list-content"
          >
            <tenCompontent  class='book_bg'
              v-for="(itemChild, idx) in multibook.list"
              :key="idx"
              @click.native="pageRead(itemChild, multibook)" :itemChild="itemChild"></tenCompontent>
          </ul>
        </div>
      </div>
    </div>
    <div class="load-more">
      <span>{{ loadingText }}</span>
    </div>
    <div v-if="isShowread" class="bottom-tips">
      <div @click="closeReadtips">
        <img src="../../static/close-read.png" alt="" />
      </div>
      <p>
        上次阅读至《{{ bookInfo.bookName }}》第{{ bookInfo.chapterOrder }}章
        {{ bookInfo.chapterName }}
      </p>
      <div @click="goRead"><p>继续</p></div>
    </div>
    <buyBook
      :showBuyMask="showBuyMask"
      :countCurrency="countCurrency"
      @buyChange="buyChange"
      :userCurrency="userCurrency"
    ></buyBook>
  </div>
  
</template>

<script>
import { Toast, MessageBox } from "mint-ui";
import uniListitem from "../view/components/list-item.vue";
import threeCompontent from "./book_item/three_compontent.vue";
import fourCompontent from "./book_item/four_compontent.vue";
import fiveCompontent from "./book_item/five_compontent_top.vue";
import sixCompontent from "./book_item/six_compontent.vue";
import eightCompontent from "./book_item/eight_compontent.vue";
import nineCompontent from "./book_item/nine_compontent.vue";
import tenCompontent from "./book_item/ten_compontent.vue";
import ListitemFour from "../view/components/list-item-four.vue";
import buyBook from "../view/components/buyBook.vue";
export default {
  components: {
    threeCompontent,
    fourCompontent,
    fiveCompontent,
    sixCompontent,
    eightCompontent,
    nineCompontent,
    tenCompontent,
    buyBook,
    uniListitem,
    ListitemFour
  },
  watch: {},
  data() {
    return {
      frequencyDefualtType:1,//1：男+女2：女+男3：仅男频4：仅女频
      listId: [],
      countCurrency: 0, //整本书币，
      showBuyMask: false, //显示整本订购弹窗
      userCurrency: 0, //用户剩余书币
      purchaseWholeBook: 0,
      items: [],
      swiperIndex: 0,
      currentIndex: 1,
      pageNo: 1,
      pageSize: 10,
      CountPage: 0,
      isReload: 1,
      //为你推荐
      multibook: {
        showTitle: "",
        componentSettingId:'',
        list: [],
        componentStyle:'',
        titleShow:0,
        jumpChoice:0
      },
      BannerList: [],
      muchCompontent: [], //组件化
      loadingText: "加载中...",
      loading: false,
      isShowread: false,
      continueReadingTips: 0,
      bookInfo: {
        bookName: "",
        bookId: "",
        chapterName: "",
        chapterOrder: "",
        chapterId: "",
      },
      isEntranceData:'',
      bookId:'',//banner和引导继续阅读的弹窗书籍id
      commonBookInfo:{
           bookName: "",
        bookId: "",
        chapterName: "",
        chapterOrder: "",
        chapterId: "",
      },
      diamondareaShowType:true
    
    };
  },
  mounted() {},
  methods: {
    getfrequencyDefualtType(){
      if (this.$base.getStorage("frequency") === "") {
        this.currentIndex = 0;
      }
        if(this.frequencyDefualtType==1){//男女
          this.items=["男频", "女频"];
          this.currentIndex = this.$base.getStorage("frequency")==1? parseInt(this.$base.getStorage("frequency")): 0;
        }else if(this.frequencyDefualtType==2){//女男
          this.items=[ "女频","男频"];
          this.currentIndex=this.$base.getStorage("frequency")==1? 0:1;
        }
        this.$base.setStorage("currentIndex", this.currentIndex);
        this.$base.setStorage("frequency", this.currentIndex);
        console.log(this.currentIndex)
    },
    getOrderStatus() {
      if (
        this.$base.getStorage("orderNum") &&
        this.$base.getStorage("isActivity")
      ) {
        var params = {
          orderNo: this.$base.getStorage("orderNum"),
          currentPageType: 1,
        };
        this.$api.getOrderStatus(params).then((res) => {
          this.$base.removeStorage("orderNum");
          this.$base.removeStorage("isActivity");
          if (res.status == 1) {
            Toast({
              message: res.message,
            });
          }
        });
      }
    },
    getOutReaderSwitckIsOpen() {
      this.$api.getOutReaderSwitckIsOpen().then((res) => {
        if (res.status == 1) {
          this.frequencyDefualtType=res.data.frequencyDefualtType;
          this.getfrequencyDefualtType();
          this.sendUserFrequency();
          var frequency=0;
          if(this.frequencyDefualtType==1){
            frequency = this.currentIndex 
        }else if(this.frequencyDefualtType==2){
            frequency =  this.currentIndex ==0?1:0;
        }else if(this.frequencyDefualtType==3){
            frequency = 0;
        }else if(this.frequencyDefualtType==4){
            frequency = 1;
        }
          this.muchCompontent = this.$base.getStorage("muchCompontent" + frequency)? JSON.parse(this.$base.getStorage("muchCompontent" + frequency)): [];
          this.BannerList = this.$base.getStorage("BannerList" + frequency)? JSON.parse(this.$base.getStorage("BannerList" + frequency)): [];
          if (!this.muchCompontent || this.muchCompontent.length == 0) {
            this.getData();
          }
          if (!this.BannerList || this.BannerList.length == 0) {
            this.getBanner();
          }
          this.insertPageAccessData();
          this.loadingText = "加载中";
          this.pageNo = 1;
          this.CountPage = 1;
          this.isReload = 1;
          this.getButtonFlowData();
        }
      });
    },
    getContinuReading(){
      this.$api.getOutReaderSwitckIsOpen().then((res) => {
        if (res.status == 1) {
      if (this.$base.getStorage("continueReading")) {
                return false;
              }
          this.continueReadingTips = res.data.continueReadingTips;
          if (this.continueReadingTips == 1) {
            this.findReadBookByMonth();
          } else {
            this.isShowread = false;
          }
        }
      })
    },
    loadMore() {
      this.loading = true;
      if (this.CountPage > this.pageNo && this.isReload == this.pageNo) {
        this.pageNo += 1;
        this.getButtonFlowData();
      } else {
        this.loading = false;
        this.loadingText = "没有更多了";
      }
    },
    insertPageAccessData() {
      var params = {
        pageName: "书城",
        pageRemark: this.currentIndex == 0 ? "男频" : "女频",
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    contentFun(diamondareaShowType) {
      this.diamondareaShowType=diamondareaShowType;
      this.getOutReaderSwitckIsOpen();
   
      this.getOrderStatus(); //判断订单号是否支付成功
    },
    findReadBookByMonth() {
      var params = {
        pageSize: 1,
        pageNo: 1,
      };
      this.$api.findReadBookByMonth(params).then((res) => {
        if (res.status == 1) {
          if (res.data.length == 1) {
            if (res.data[0].chapterOrders > 0) {
              this.isShowread = true;
              this.bookInfo.chapterOrder = res.data[0].chapterOrders;
              this.bookInfo.bookName = res.data[0].bookName;
              this.bookInfo.chapterName = res.data[0].chapterName;
              this.bookInfo.bookId = res.data[0].id;
              this.bookInfo.chapterId = res.data[0].chapterId;
            } else {
              this.isShowread = false;
            }
          } else {
            this.isShowread = false;
          }
        }
      });
    },
    goRead() {
      var isEntranceData = "";
      this.commonRead(this.bookInfo, isEntranceData);
    },
    closeReadtips() {
      this.isShowread = false;
      this.$base.setStorage("continueReading", 1);
    },
    buyChange(data) {
      if (data) {
        if (data == 1) {
          this.purchaseWholeBook = 1;
          this.commonRead(this.commonBookInfo, this.isEntranceData)
        } else if (data == 2) {
          this.showBuyMask = false;
          this.$router.push({
            path: "/pages/bookCharge/index",
            query: {
              bookId: this.bookId,
              needCurrency: this.countCurrency,
              pageType: "bookRead",
            },
          });
        }
      } else {
        this.showBuyMask = false;
      }
    },
    commonRead(bookInfo, isEntranceData) {
      //判断书籍是否能进入阅读器
      this.bookId=bookInfo.bookId;
       this.isEntranceData=isEntranceData;
       this.commonBookInfo=bookInfo;
      var params = {
        bookId: bookInfo.bookId,
        chapterId: bookInfo.chapterId,
        chapterorder: bookInfo.chapterOrder,
        order: 0,
        booktype: "",
        isauto: 0,
        rechargeOrderNum: "", //订单编号
        purchaseWholeBook: this.purchaseWholeBook,
        currentPageType: 1,
      };
     
      this.$api.findChapterContentByChapterId(params).then((res) => {
        if (res.status == 1) {
          this.showBuyMask = false;
          this.purchaseWholeBook = 0;
          this.$router.push({
            path: "/pages/bookRead/index",
            query: {
              bookid: bookInfo.bookId,
              pageType: "bookCity",
              isEntranceData: isEntranceData,
            },
          });
        } else if (res.status == 3) {
          this.showBuyMask = true;
          this.countCurrency = res.data.wholeBookCurrency;
          this.userCurrency = res.data.accountCurrency;
        } else if (res.status == 100 || res.status == 200||res.status==4) {
          if (res.data) {
            if(res.status==100&&res.data.priceType==3){
              this.$router.push({
                path: "/pages/bookCharge/index",
                query: {
                  bookId: bookInfo.bookId,
                  chapterId: res.data.id,
                  needCurrency: res.data.chapterPrice,
                  pageType: "bookRead",
                  priceType:res.data.priceType
                },
              });
              }else{
                this.$router.push({
                path: "/pages/bookCatalog/index",
                query: {
                  bookId:bookInfo.bookId,
                  pageType: "bookCity",
                  isEntranceData: isEntranceData
                },
              });
              } 
          }
        }
      });
    },
    goDetail(item) {
      //banner跳转，点击上报
      //书籍详情
      var isEntranceData = '(1:'+item.id+':'+item.type+':'+item.clickBehaviorFlag+':'+item.bannerType+':'+item.orderNum+')' ;
      if (item.type == 0) {
        if (item.jumpChoice == 1) {
          this.commonRead(item, isEntranceData);
          return false;
        } else {
          this.$router.push({
            path: "/pages/bookDetail/index",
            query: {
              bookId: item.bookId,
              pageType: "bookCity",
              isEntranceData: isEntranceData,
            },
          });
        }
      } else if (item.type == 2) {
        //活动充值页
        this.$router.push({
          path: "/pages/bookModelActivity/index",
          query: {
            activityId: item.activityId,
            pageType: "bookCity",
            isEntranceData: isEntranceData,
          },
        });
      } else if (item.type == 1) {
        //url调换
        this.$router.push({
          path: "/pages/bookWeb/index",
          query: {
            url: item.url,
            pageType: "bookCity",
            isEntranceData: isEntranceData,
          },
        });
      } else if (item.type == 4||item.type==5) {
        //跳转到任意页面
        var params = { pageType: "bookCity", isEntranceData: isEntranceData};
        if(item.pageUri=='/?tabIndex=0'||item.pageUri=='/?tabIndex=1'||item.pageUri=='/?tabIndex=2'||item.pageUri=='/?tabIndex=3'){
          var type=item.pageUri.split('=')[1]
                 this.$emit("eventChange", { data: type });
        }else{
             this.$router.push({
          path: item.pageUri,
          query: params,
        });

        }
     
      }else if (item.type == 6) {
        //领取优惠券跳转
       this.$router.push({
          path: "/pages/getCoupons/index",
          query: {
            couponIds: item.couponIds,
            pageType:  "bookCity",
            isEntranceData: isEntranceData
          },
        });
      }
    },
    routerSort() {
      this.$router.push({
        path: "/pages/bookSort/index",
        query: { pageType: "bookCity" },
      });
    },
    routerClass() {
      this.$router.push({
        path: "/pages/bookClass/index",
        query: { pageType: "bookCity" },
      });
    },
    routerFree() {
      this.$router.push({
        path: "/pages/bookFree/index",
        query: { pageType: "bookCity" },
      });
    },
    pageRead(item, parentItem) {
      console.log(parentItem)
      var isEntranceData="(5:"+parentItem.componentSettingId+':-1:'+item.id+':'+this.currentIndex+':-1)'
      if(parentItem.jumpChoice==0){
        this.$router.push({
        path: "/pages/bookDetail/index",
        query: { bookId: item.id,isEntranceData:isEntranceData,pageType: "bookCity"  },
      });
      }else{
        item.bookId=item.id;
        item.chapterOrder='';
        item.chapterId='';
        this.commonRead(item, isEntranceData);
      }
    },
    onClickItem(index) {
      if (this.currentIndex != index) {
        this.currentIndex = index;
        this.loadingText = "加载中...";
        this.sendUserFrequency();
        var frequency=0;
          if(this.frequencyDefualtType==1){
            frequency = this.currentIndex 
        }else if(this.frequencyDefualtType==2){
            frequency =  this.currentIndex ==0?1:0;
        }else if(this.frequencyDefualtType==3){
            frequency = 0;
        }else if(this.frequencyDefualtType==4){
            frequency = 1;
        }
        this.muchCompontent = this.$base.getStorage(
          "muchCompontent" + frequency
        )
          ? JSON.parse(
              this.$base.getStorage("muchCompontent" + frequency)
            )
          : [];
        this.BannerList = this.$base.getStorage(
          "BannerList" + frequency
        )
          ? JSON.parse(this.$base.getStorage("BannerList" + frequency))
          : [];
        if (!this.muchCompontent || this.muchCompontent.length == 0) {
          this.getData();
        }
        if (!this.BannerList || this.BannerList.length == 0) {
          this.getBanner();
        } else {
          this.$nextTick(() => {
            this.swiperIndex = 0;
            this.$refs.swipe.swipeItemCreated();
          });
        }
        this.pageNo = 1;
        this.CountPage = 1;
        this.isReload = 1;
        this.getButtonFlowData();
        this.insertPageAccessData();
      }
    },
    sendUserFrequency() {
      var frequency='';
          if(this.frequencyDefualtType==1){
            frequency = this.currentIndex 
        }else if(this.frequencyDefualtType==2){
            frequency =  this.currentIndex ==0?1:0;
        }else if(this.frequencyDefualtType==3){
            frequency = 0;
        }else if(this.frequencyDefualtType==4){
            frequency = 1;
        }
      var params = {
        frequency:frequency
      };
      this.$api.sendUserFrequency(params).then((res) => {
        if (res.status == 1) {
          this.$base.setStorage("currentIndex", this.currentIndex);
          this.$base.setStorage("frequency", frequency);
        }
      });
    },
    getBanner() {
      var frequency=0;
          if(this.frequencyDefualtType==1){
            frequency = this.currentIndex 
        }else if(this.frequencyDefualtType==2){
            frequency =  this.currentIndex ==0?1:0;
        }else if(this.frequencyDefualtType==3){
            frequency = 0;
        }else if(this.frequencyDefualtType==4){
            frequency = 1;
        }
      this.$api
        .getBanner({
          type: frequency+ 2,
        })
        .then((res) => {
          // 获得数据
          if (res.status == 1) {
            this.BannerList = res.data;
            this.$base.setStorage(
              "BannerList" + frequency,
              JSON.stringify(this.BannerList)
            );
            setTimeout(() => {
              this.swiperIndex = 0;
              if(this.BannerList.length>0){
                this.$refs.swipe.swipeItemCreated();
              }
         
            }, 100);
          }
        })
        .catch((res) => {
          // 失败进行的操作
        });
    },
    getData() {
      var frequency=0;
          if(this.frequencyDefualtType==1){
            frequency = this.currentIndex 
        }else if(this.frequencyDefualtType==2){
            frequency =  this.currentIndex ==0?1:0;
        }else if(this.frequencyDefualtType==3){
            frequency = 0;
        }else if(this.frequencyDefualtType==4){
            frequency = 1;
        }
      this.$api
        .getBookCityData({
          frequency: frequency,
        })
        .then((res) => {
          // 获得数据
          if (res.status == 1) {
            res.data.forEach((item) => {
              item.bookList.forEach((obj) => {
                var num = (obj.studyingVolume / 10000).toFixed(2);
                if (num >= 999.99) {
                  obj.studyingVolume = 999.99;
                } else {
                  obj.studyingVolume = num;
                }
              });
            });
            this.muchCompontent = res.data;
            this.$base.setStorage(
              "muchCompontent" + frequency,
              JSON.stringify(this.muchCompontent)
            );
          }
        })
        .catch((res) => {
          // 失败进行的操作
        });
    },
    routeSearch() {
      this.$router.push({
        path: "/pages/bookSearch/index",
        query: {
          pageType: "bookCity",
        },
      });
    },
    getButtonFlowData() {
      this.listId = [];
      if (this.pageNo > 1) {
        this.multibook.list.forEach((item) => {
          this.listId.push(item.id);
        });
      }
      var frequency=0;
          if(this.frequencyDefualtType==1){
            frequency = this.currentIndex 
        }else if(this.frequencyDefualtType==2){
            frequency =  this.currentIndex ==0?1:0;
        }else if(this.frequencyDefualtType==3){
            frequency = 0;
        }else if(this.frequencyDefualtType==4){
            frequency = 1;
        }
      var params = {
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        frequency: frequency,
        idColllection: this.listId,
      };
      this.$api
        .getButtonFlowData(params)
        .then((res) => {
          // 获得数据
          if (res.status == 1) {
            this.isReload = this.pageNo;
            this.CountPage = res.pages;
            res.data.forEach((item) => {
              var num = (item.studyingVolume / 10000).toFixed(2);
              if (num >= 999.99) {
                item.studyingVolume = 999.99;
              } else {
                item.studyingVolume = num;
              }
            });
            this.multibook.showTitle = res.showTitle;
            this.multibook.componentStyle = res.componentStyle;
            this.multibook.titleShow = res.titleShow;
            this.multibook.componentSettingId = res.componentSettingId;
            this.multibook.jumpChoice = res.jumpChoice;
            if (this.pageNo == 1) {
              this.multibook.list = res.data;
              if (this.CountPage > 1) {
                this.loadingText = "加载中...";
              } else {
                this.loadingText = "没有更多了";
              }
            } else {
              this.multibook.list = this.multibook.list.concat(res.data);
            }
          }
        })
        .catch((res) => {
          // 失败进行的操作
        });
    },
  },
};
</script>

<style scoped>
/* .book_bg:nth-child(4n-3){
  background: #FDFAF6;
}
.book_bg:nth-child(4n-2),.book_bg:nth-child(4n-1){
  background:  #F9FBFF;
}
.book_bg:nth-child(4n){
  background: #FFF9F9;
} */
.bottom-tips {
  position: fixed;
  width: 90%;
  background-color: rgba(28, 26, 26, 0.71);
  border-radius: 9px;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  bottom: calc(64px + constant(safe-area-inset-bottom));
  bottom: calc(64px + env(safe-area-inset-bottom));
}
.bottom-tips > div:nth-child(1) {
  width: 30px;
  height: 40px;
  text-align: center;
  /* line-height: 40px; */
  padding-left: 16px;
  margin-right: 10px;
  box-sizing: border-box;
}
.bottom-tips > div {
  width: 80px;
  height: 40px;
}
.bottom-tips > div > img {
  width: 14px;
  height: 14px;
  margin-top: 13px;
}
.bottom-tips > p {
  font-size: 12px;
  overflow: hidden;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  height: 20px;
  line-height: 20px;
  margin-top: 10px;
  width: 220px;
}
.bottom-tips > div > p {
  margin: 0 auto;
  color: #ffffff;
  width: 42px;
  height: 24px;
  background-color: #de3b34;
  border-radius: 8px;
  text-align: center;
  line-height: 24px;
  margin-top: 8px;
  margin-right: 16px;
  font-size: 12px;
}
.container {
  padding: 12px 16px;
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  /* box-sizing: content-box; */
}
.uni-padding-wrap {
  display: flex;
  flex-direction: row;
  justify-items: flex-end;
  box-sizing: border-box;
  overflow: hidden;
  padding: 12px 16px;
  justify-content: space-between;
  position: fixed;
  top: 0px;
  z-index: 99;
  background-color: #ffffff;
  width: 100%;
  padding-top: 24px;
  left: 0;
}

.uni-common-frency {
  display: flex;
}
.uni-common-frency > div:nth-child(1) {
  margin-right: 36px;
}
.segmented-control-item {
  font-size: 16px;
  color: #aaaaaa;

  border-bottom: 3px solid #ffffff;
  padding-bottom: 4px;
}

.uni-padding-wrap .active {
  color: #de3b34;
  border-bottom: 3px solid #de3b34;
}

.search-item {
  background-color: #f3f3f3;
  border-radius: 4px;
  display: flex;
  padding: 5px 27px;
}

.search-item > .search-image {
  width: 17px;
  height: 17px;
}

.search-item > .search-text {
  font-size: 14px;
  color: #aaaaaa;
  margin-left: 8px;
}
.contaner-banner {
  margin-top: 67px;
}
.page-section-spacing {
  margin-bottom: 16px;
}

.swiper {
  height: 124px;
}

.swiper-item {
  width: 100%;
  height: 100%;
}

.swiper-item > .swiper-image {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.uni-page-sort {
  display: flex;
  justify-content: space-between;
}

.uni-page-sort-item {
  text-align: center;
  flex: 1;
}

.uni-page-sort-image {
  width: 50px;
  height: 50px;
  display: block;
  margin: 6px auto;
}
.list_top{
  margin-bottom:20px;
}
.list-content,.list-content-four {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: space-between;
}
.list-content:after {
  content: "";
 width:96px;  
}
.list-content-four:after {
  content: "";
 width:70px;  
}
.uni-components>div{
  margin-top: 16px;
  margin-bottom: 30px;
}
.uni-components-title {
  font-size: 15px;
  color: #333333;
  font-weight: bold;
  /* margin-top: 16px; */
  margin-bottom: 16px;
}

.load-more {
  text-align: center;
  font-size: 12px;
  color: #aaaaaa;
  padding: 16px 0px;
}

.search-item > .search-text {
  font-size: 14px;
}
.search-item {
  padding: 3px 27px;
}
.search-item > .search-image {
  width: 17px;
  height: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/bookCity.vue